module.exports = __webpack_public_path__ + "static/regiao-metropolitana-rio-de-janeiro-3d03a195ecb1b6eae3a37693f5a4da36.jpg";